import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export function scrollIntoView(child, viewingArea) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      _ref$startMargin = _ref.startMargin,
      startMargin = _ref$startMargin === void 0 ? 0 : _ref$startMargin,
      _ref$endMargin = _ref.endMargin,
      endMargin = _ref$endMargin === void 0 ? 0 : _ref$endMargin,
      _ref$behavior = _ref.behavior,
      behavior = _ref$behavior === void 0 ? 'smooth' : _ref$behavior;

  var startSide = direction === 'vertical' ? 'top' : 'left';
  var endSide = direction === 'vertical' ? 'bottom' : 'right';
  var scrollSide = direction === 'vertical' ? 'scrollTop' : 'scrollLeft';

  var _child$getBoundingCli = child.getBoundingClientRect(),
      childStart = _child$getBoundingCli[startSide],
      childEnd = _child$getBoundingCli[endSide];

  var _viewingArea$getBound = viewingArea.getBoundingClientRect(),
      viewingAreaStart = _viewingArea$getBound[startSide],
      viewingAreaEnd = _viewingArea$getBound[endSide];

  var isChildStartAboveViewingArea = childStart < viewingAreaStart + startMargin;
  var isChildBottomBelowViewingArea = childEnd > viewingAreaEnd - endMargin;

  if (isChildStartAboveViewingArea) {
    var scrollHeightToChildStart = childStart - viewingAreaStart + viewingArea[scrollSide];
    viewingArea.scrollTo(_defineProperty({
      behavior: behavior
    }, startSide, scrollHeightToChildStart - startMargin));
  } else if (isChildBottomBelowViewingArea) {
    var scrollHeightToChildBottom = childEnd - viewingAreaEnd + viewingArea[scrollSide];
    viewingArea.scrollTo(_defineProperty({
      behavior: behavior
    }, startSide, scrollHeightToChildBottom + endMargin));
  }
}